import { Typography } from "@mui/material"
import { BellAlertBanner } from "@pharmupp/p3-front-commons"

const lastYearMessage = (
  <>
    <Typography fontWeight="bold" display="inline" component="span">
      Clôture de fin d’année :
    </Typography>{" "}
    les données sont en cours de consolidation. Mise à jour très prochainement !
  </>
)

const getNextYearMessage = (
  <>
    <Typography fontWeight="bold" display="inline" component="span">
      Nouvelle année :
    </Typography>{" "}
    Les données sont progressivement mises à jour d’ici avril, un peu de patience...
  </>
)

const currentDate = new Date()

export const getAlertMessage = (today: Date, year: number) => {
  const currentYear = today.getFullYear()
  const currentMonth = today.getMonth() // careful, it's 0-based

  if ([0, 1].includes(currentMonth)) {
    // january & february
    if (year === currentYear - 1) {
      return lastYearMessage
    }
    if (year === currentYear) {
      return getNextYearMessage
    }
  } else if (currentMonth === 2) {
    // march
    if (year === currentYear - 1) {
      return undefined
    }
    if (year === currentYear) {
      return getNextYearMessage
    }
  } else if (currentMonth === 11) {
    // december
    if (year === currentYear) {
      return lastYearMessage
    }
    if (year === currentYear + 1) {
      return getNextYearMessage
    }
  }

  return undefined
}
export const LoyaltyCategoryAlert = ({ year }: { year: number }) => {
  const message = getAlertMessage(currentDate, year)

  return (
    <>{!!message && <BellAlertBanner sx={{ mt: 3 }}>{message}</BellAlertBanner>}</>
  )
}
